<template>
	<div ref="stream" class="stream-wrapper">
	</div>
</template>



<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "AudioTrack", 
		props: {
			track: {},
		},
		data: () => {
			return {

			}
		},
		watch:{
			track: {
				handler(nv, ov){
					if( nv !== ov ){
						if( !this.track ){
							return;
						}
						if( this.track.attach ){
							this.$refs.stream.appendChild( this.track.attach() )
						}
					}
				}
			}
		},
		mounted(){
			if( !this.track ){
				return;
			}
			if( this.track.attach ){
				this.$refs.stream.appendChild( this.track.attach() )
			}

		}

	}
// </script>"